export default [{
        path: '/401',
        name: 'error_401',
        meta: {
            hideInMenu: true,
        },
        component: () =>
            import('_v/error-page/401.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true,
        },
        component: () =>
            import('_v/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        meta: {
            hideInMenu: true,
        },
        component: () =>
            import('_v/error-page/404.vue')
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            hideInMenu: true,
            cache: {
                // 租户代码
                tenantCode: {
                    defaultVal: '', // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                }
            }
        },
        component: () =>
            import('_v/login/login')
    },
]